import { createComponent as _$createComponent } from "solid-js/web";
/**
 * Ground Layer - Orchestrates traffic, CCTV, seismic, tactical, drone,
 * threat-heatmap and sun/shadow sub-layers.
 */

import { Show } from "solid-js";
import { groundState } from "./store.ts";
import { TrafficLayer } from "./TrafficLayer.tsx";
import { GoogleTrafficLayer } from "./GoogleTrafficLayer.tsx";
import { CCTVLayer } from "./CCTVLayer.tsx";
import { SeismicLayer } from "./SeismicLayer.tsx";
import { TacticalLayer } from "./TacticalLayer.tsx";
import { DroneLayer } from "./DroneLayer.tsx";
import { ThreatHeatmapLayer } from "./ThreatHeatmapLayer.tsx";
import { SunShadowLayer } from "./SunShadowLayer.tsx";
export function GroundLayer() {
  return [_$createComponent(Show, {
    get when() {
      return groundState.trafficEnabled;
    },
    get children() {
      return _$createComponent(GoogleTrafficLayer, {});
    }
  }), _$createComponent(Show, {
    get when() {
      return groundState.trafficEnabled;
    },
    get children() {
      return _$createComponent(TrafficLayer, {});
    }
  }), _$createComponent(CCTVLayer, {}), _$createComponent(Show, {
    get when() {
      return groundState.seismicEnabled;
    },
    get children() {
      return _$createComponent(SeismicLayer, {});
    }
  }), _$createComponent(Show, {
    get when() {
      return groundState.tacticalEnabled;
    },
    get children() {
      return _$createComponent(TacticalLayer, {});
    }
  }), _$createComponent(Show, {
    get when() {
      return groundState.dronesEnabled;
    },
    get children() {
      return _$createComponent(DroneLayer, {});
    }
  }), _$createComponent(ThreatHeatmapLayer, {}), _$createComponent(SunShadowLayer, {})];
}